import FieldDefs from './AllAdsFieldDefs.js'
import {doLangFields} from '../../lib/ks-tools'
import AllRsyAd from "../../component/rsy-ads/AllRsyAd.vue";
import Carousel from "primevue/carousel";
import Dialog from "primevue/dialog";
import {Listeners} from "../../constants/listeners";

export default {
    components: {Dialog, Carousel, AllRsyAd},
    template: `<div><slot v-bind="self"/>
        <Dialog class="rsya-dialog-carousel" v-model:visible="visible" modal :draggable="false" header=" " dismissableMask blockScroll>
                <Carousel
                    :value="carouselGroup"
                    :numVisible="carouselVisible"
                    :numScroll="carouselScroll"
                    :show-indicators="false"
                    v-model:page="carouselPage"
                    :responsive-options="carouselResponsive"
                    :pt="{
                        previousButtonIcon: { class: 'text-primary' },
                        nextButtonIcon: { class: 'text-primary' },
                        nextButton: { class: 'rsya-carousel-button' },
                        previousButton: { class: 'rsya-carousel-button' }
                    }"
                >
                    <template #item="slotProps">
                        <all-rsy-ad disable-fancy :key="slotProps.data.id" :ad="slotProps.data" class="rsya_item" style="margin: 0 auto"></all-rsy-ad>
                    </template>
                </Carousel>
        </Dialog>
    </div>`,
    data() {
        return {
            mounted: false,
            appendParams: {
                groupingBy: "",
            },
            tileView: true,
            fields: doLangFields(this, "lang.report.rsy-ads", FieldDefs),
            sortOrder: [],
            additionalActions: [],
            showAllLegalInfo: false,

            carouselValue: [],
            carouselGroup: [],
            visible: false,
            carouselPage: 0,
            carouselVisible: 5,
            carouselScroll: 5,
            carouselResponsive: [

                {
                    breakpoint: '1650px',
                    numVisible: 4,
                    numScroll: 4
                },
                {
                    breakpoint: '1300px',
                    numVisible: 3,
                    numScroll: 3
                },
                {
                    breakpoint: '1010px',
                    numVisible: 2,
                    numScroll: 2
                },
                {
                    breakpoint: '730px',
                    numVisible: 1,
                    numScroll: 1
                }
            ],
        }
    },
    computed: {
        groupingAvailable() {
            if (!this.mounted) {
                return false;
            }

            if (this.$parent.$refs.filter.filter.length === 0) {
                this.appendParams.groupingBy = "";
            }

            return this.$parent.$refs.filter.filter.length >= 2;
        },
        getApiUrl(){
            return '/report/ads/rsya';
        },
        self() {
            return this;
        },
        data() {
            return this.$parent.$refs.ksTable.$refs.vuetable.tableData
        }
    },
    mounted() {
        // необходимо для работы computed
        this.mounted = true;

        // переключение между типом отображения вызывает mounted из-за чего слушатель добавляется несколько раз
        this.$emitter.off(Listeners.RSYA_POPUP_GROUPING_OPEN);
        this.$emitter.on(Listeners.RSYA_POPUP_GROUPING_OPEN, this.openModal);

        if (localStorage.getItem('rsyAdsTileView') === 'false') {
            this.toggleView(false);
        }
    },
    watch: {
        showAllLegalInfo() {
            this.$emitter.emit('showAllLegalInfo', this.showAllLegalInfo);
        },
        visible: function() {
            this.carouselPage = 0
        },
        carouselPage: function (newPage, oldPage) {
            if (newPage > oldPage) {
                if (this.carouselValue && this.carouselGroup.length < this.carouselValue.group.length) {
                    const start = this.carouselGroup.length;
                    const end = start + this.carouselVisible;
                    this.carouselGroup.push(...this.carouselValue.group.slice(start, end));
                }
            }
        }
    },

    methods: {
        openModal(adid) {
            this.carouselValue = this.data.find(ad => ad.id === adid) || { group: [] };
            this.carouselGroup = this.carouselValue.group.slice(0, this.carouselVisible * 2);
            this.visible = true;
        },
        toggleView(val) {
            localStorage.setItem('rsyAdsTileView', val);

            this.tileView = val;

            for (let field of this.fields.filter(f => f.switchable)) {
                field.visible = !this.tileView;
            }
            this.$parent.$refs.ksTable.normalizeFields();
        }
    }

}
